import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import { studentDiscussionFetch } from '../../../actions/digitalDoubtActions';
import { studentDiscussionFetch as teacherDiscussionFetch } from '../../../actions/teacherDigitalDoubtActions';
// Material Imports
import { Grid, Card, Tab, Tabs } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
// import { useTheme } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';
import PageHeading from '../../../components/PageHeading';
import NoData from '../../../components/NoData';

export default function DoubtTopics() {
  //Mobile Tab Design
  // const theme = useTheme();
  // const matches = useMediaQuery(theme.breakpoints.up('sm'));
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [value, setValue] = React.useState(0);
  // Redux
  const dispatch = useDispatch();
  const jwt = useSelector(state => get(state, 'loginReducer.data.jwt', ''));
  const doubtTopicsList = useSelector(state =>
    get(state, 'digitalDoubtReducer.doubtTopics.listSubject', [])
  );
  const userType = useSelector(state =>
    get(state, 'loginReducer.userType', '')
  );
  const errorMessage = useSelector(state =>
    get(state, 'digitalDoubtReducer.errorMessage', '')
  );

  useEffect(() => {
    setIsFetching(true);
    (userType === 'student'
      ? studentDiscussionFetch(jwt, dispatch)
      : teacherDiscussionFetch(jwt, dispatch)
    ).then(() => {
      setIsFetching(false);
    });
  }, []);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <p>{children}</p>}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
  };

  const populateDoubtList = () => {
    let tabLabels = [];
    const list = [];
    const dummytabs = [1, 1, 1];
    (isFetching ? dummytabs : doubtTopicsList).map((data, index) => {
      let topics = [];

      tabLabels.push(
        isFetching ? (
          <div className="mr-10" style={{ width: '100px' }}>
            <Skeleton variant="text" />
          </div>
        ) : (
          <Tab label={data.SubjectName.toUpperCase()} />
        )
      );
      (isFetching ? dummytabs : data.listForum).map((topicData, subIndex) => {
        let key = `${index}${subIndex}`;
        return topics.push(
          <Grid item xs={6} sm={6} md={3} key={index}>
           

<Link to={{
  pathname: `/digital-doubt-counter/${topicData.UniqueCode}/${topicData.ForumID}`,
  state: {
    formid: topicData.ForumID
  }
}}>


            
              <Card elevation="0" className="card chapter-card" key={key}>
                <p className="topic mb-5">
                  {isFetching ? (
                    <Skeleton variant="text" />
                  ) : (
                    topicData.ForumTitle
                  )}
                </p>
                <p className="sub-text">
                  {isFetching ? (
                    <Skeleton variant="text" />
                  ) : (
                    <>Doubt Asked: {topicData.TotalQuestion}</>
                  )}
                </p>
              </Card>
            </Link>
          </Grid>
        );
      });
      return list.push(
        <TabPanel value={value} index={index} className="panel">
          <Grid container spacing={2} className="panel-body">
            {topics}
          </Grid>
        </TabPanel>
      );
    });
    return (
      <React.Fragment>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="line-tab"
        >
          {tabLabels}
        </Tabs>
        {list}
      </React.Fragment>
    );
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Digital Doubt" titleSecondary="Counter" />
      {isFetching || (doubtTopicsList && doubtTopicsList.length > 0) ? (
        <div className="flex-column">{populateDoubtList()}</div>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </React.Fragment>
  );
}
